import React from "react";

import TextStyles from "../../../../../../../Constants/TextStyles";
import Styled from "../AddSectionStyles";
// import textBtn from "../../../../../../../Assets/assetsnew/text-image-new.svg";

const Text = ({ data }) => {
  return (
    <Styled.ReviewBox>
      {/* <div className="d-flex align-items-center gap-3 mb-4"> */}
      {/* <img src={textBtn} alt="textImageBtn" style={{ maxWidth: "2.2rem" }} /> */}

      <TextStyles.FontSize18px className="fw-medium mb-3">
        {data.text_title}
      </TextStyles.FontSize18px>
      {/* </div> */}

      <p className="m-0 lh-lg">{data.textarea}</p>
    </Styled.ReviewBox>
  );
};

export default Text;
